import { Computer, DirectionsCar, ErrorOutline } from '@mui/icons-material';
import { Chip } from '@mui/material';

export function MethodOfInspectionChip({
  methodOfInspection,
  variant = 'outlined',
  size = 'small',
}: {
  methodOfInspection: string;
  variant?: 'outlined' | 'filled';
  size?: 'small' | 'medium';
}) {
  return (
    <Chip
      label={getLabel(methodOfInspection)}
      color={getColor(methodOfInspection)}
      size={size}
      icon={getIcon(methodOfInspection)}
      variant={variant}
      data-testid="methodOfInspection"
    />
  );
}

const getColor = (methodOfInspection: string) => {
  switch (methodOfInspection) {
    case 'FIELD':
      return 'info';
    case 'VIRTUAL':
      return 'warning';
    default:
      return 'error';
  }
};

const getLabel = (methodOfInspection: string) => {
  switch (methodOfInspection) {
    case 'FIELD':
      return 'Field';
    case 'VIRTUAL':
      return 'Virtual';
    default:
      return 'unknown';
  }
};

const getIcon = (methodOfInspection: string) => {
  switch (methodOfInspection) {
    case 'FIELD':
      return <DirectionsCar />;
    case 'VIRTUAL':
      return <Computer />;
    default:
      return <ErrorOutline />;
  }
};
